import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stunning%20artistic%20watermelon%20sculpted%20into%20a%20ninja%20character%20from%20Naruto%2C%20sliced%20watermelon%20pieces%20arranged%20creatively%2C%20dark%20dramatic%20background%20with%20subtle%20smoke%20effects%2C%20professional%20food%20photography%20style%2C%20vivid%20green%20and%20red%20watermelon%20colors%20contrasting%20dark%20background%2C%20Japanese%20aesthetic%20elements&width=1800&height=900&seq=hero-main-01&orientation=landscape"
        alt="火影西瓜——忍者迷必收的创意西瓜玩法"
        title="火影西瓜创意忍者西瓜造型展示"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full text-center px-4 md:px-6">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            火影西瓜
          </h1>
          <p className="text-white/80 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            融合火影忍者主题与西瓜创意的爆款玩法，涵盖火影西瓜造型DIY、主题切法、周边产品推荐，带你解锁忍者风夏日吃瓜新姿势，火影粉必看！
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/zaoxing-diy"
              className="px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              开始DIY教程
            </Link>
            <Link
              to="/category/zhuti-qiefa"
              className="px-6 py-3 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/30 transition-all whitespace-nowrap cursor-pointer"
            >
              探索切法技巧
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}